<div class="se-external-docs-popup window-container">
    <div class="dialog-container">
        <div class="se-dialog-header mat-elevation-z6">
            <h3 *ngIf="isAddingDoc" style="margin:0" class="se-dialog-title" translate>ImportNewDocument</h3>
            <h3 *ngIf="isEditingDoc" style="margin:0" class="se-dialog-title" translate>ModifyDocument</h3>
        </div>

        <div class="se-dialog-content">

            <mat-slide-toggle name="externalDocumentDossier" *ngIf="selectedDocType === 0"
                              style="margin-bottom:20px"
                              [(ngModel)]="internalDoc.addToPatientDossier"
                              labelPosition="after">
                {{'PatientDossier' | translate}}
            </mat-slide-toggle>

            <mat-form-field *ngIf="selectedDocType === 0" style="margin-bottom:15px">
                <mat-label> {{'EventDate' | translate}}</mat-label>
                <input name="eventDatePicker" [(ngModel)]="internalDoc.eventDateTime" matInput [matDatepicker]="eventDatePicker" required>
                <mat-datepicker-toggle matSuffix [for]="eventDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #eventDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field *ngIf="selectedDocType === 1" style="margin-bottom:15px">
                <mat-label>{{'DocumentType' | translate}}</mat-label>
                <mat-select name="externalDocumentDocumentType" [(ngModel)]="internalDoc.docType" required>
                    <mat-option value="F12BDCC7-A147-4246-BFFC-83D3730BB991">{{'Finding' | translate}}</mat-option>
                    <mat-option value="A2948E0C-5F3E-4FA4-BD57-2BB30133CCB1">{{'ExtDoc_Privacy' | translate}}</mat-option>
                    <mat-option value="84C94665-479E-46EE-9224-8D25F7F24E7D">{{'ExtDoc_Assurance' | translate}}</mat-option>
                    <mat-option value="B70A8DC4-90D8-4F5E-987A-647FA61B7785">{{'ExtDoc_GenericDoc' | translate}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field style="margin-bottom:15px">
                <mat-label>{{ 'Description' | translate }}</mat-label>
                <input name="externalDocumentDescription"
                       matInput placeholder="{{'Description' | translate}}"
                       type="text"
                       [(ngModel)]="internalDoc.eprDescription">
            </mat-form-field>
        </div>

        <div style="display:flex;flex-direction:row-reverse" *ngIf="isEditingDoc || isAddingDoc">
            <button mat-button
                    color="primary"
                    style="font-size:1em; margin:10px;"
                    type="button"
                    (click)="onCancelOps()">
                <p style="margin:0" translate>Cancel</p>
            </button>

            <button mat-button
                    type="submit"
                    [disabled]="!canConfirm(selectedDocType)"
                    color="primary"
                    style="font-size:1em; margin:10px;"
                    type="button"
                    (click)="onConfirmOps()">
                <p style="margin:0" translate>Ok</p>
            </button>
        </div>

    </div>
   
</div>

